import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../store/app";
import {
  Button,
  Card,
  Dropdown,
  Grid,
  Input,
  Skeleton,
  Space,
  Tooltip,
  Modal,
  Slider,
  ConfigProvider,
  Radio,
  BackTop,
} from "antd";
import { ArrowUpOutlined, DownOutlined, SearchOutlined } from "@ant-design/icons";
import {
  addRemoveJob,
  fetchCareerCategorys,
  fetchSavedJobs,
} from "../Utils/slice";
import "../../../../../assets/styles/custom/customStyles/cutomStyles.css";
import SVGIcon from "../../../../../utils/SVGIcon";
import FilterModal from "../AllCareers/FilterModal";
import { Link, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatGlobalPrice } from "../../../../../config/Global";
import { SaveCareersIndexBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import ArrowDown from "../../../../../assets/images/arrow_down.svg";
import CustomRadio from "../AllCareers/CustomRadio";
import { CONSTANT } from "../../../../../config/Constant";

/**
 * Strips HTML tags from a string and returns only text content
 */
const stripHtml = (html: string) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const { useBreakpoint } = Grid;

const SavedJobs = () => {
  const savedjobs = useSelector(
    (state: RootState) => state.WEBPROFILE.savedJobList
  );
  const careerListPagination = useSelector(
    (state: RootState) => state.WEBPROFILE.pagination
  );
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState<number>(1);
  const [salaryModalVisible, setSalaryModalVisible] = useState(false);
  const [showName, setShowName] = useState<string>("");
  const screens = useBreakpoint();
  const [CarierCategoryList, setCarierCategoryList] = useState<any>([]);
  const [mobileFilterVisible, setMobileFilterVisible] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [showFilterCount, setShowFilterCount] = useState(false);

  const careerListCount = useSelector(
    (state: RootState) => state.WEBPROFILE.saveCount
  );
  console.log("careerListCount", careerListCount);

  const sortOptions = [
    { label: "Name: A → Z", value: "ASC", data: "name" },
    { label: "Name: Z → A", value: "DESC", data: "name" },
    { label: "Salary: Low to High", value: "ASC1", data: "salary_avg" },
    { label: "Salary: High to Low", value: "DESC1", data: "salary_avg" },
  ];
  const [sortOrder, setSortOrder] = useState("ASC");

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [salaryRange, setSalaryRange] = useState<[string, string]>(["", ""]);
  const [salaryRangeInput, setSalaryRangeInput] = useState<[string, string]>(["", ""]);
  const [sortBy, setSortBy] = useState<string>("name");


  const [scrollY, setScrollY] = useState(0);

  const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    ReloadTable();
    dispatch(fetchCareerCategorys())
      .then((data: any) => {
        setLoading(false);
        setCarierCategoryList([
          { id: "all", full_name: "All Categories" },
          ...data.data,
        ]);
      })
      .catch((e: any) => {
        setCarierCategoryList([]);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchValue(inputValue);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  const ReloadTable = () => {
    setLoading(true);
    console.log("sortBy", sortBy);
    setPage(1);
    const categoryPass =
      selectedCategory && selectedCategory != "all" ? selectedCategory : null;
    dispatch(
      fetchSavedJobs(
        searchValue,
        categoryPass,
        1,
        sortOrder == "ASC" || sortOrder == "ASC1" ? "ASC" : "DESC",
        salaryRange[0],
        salaryRange[1],
        sortBy
      )
    )
      .then((data: any) => {
        setPage(page + 1);
        setLoading(false);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };

  const SaveAndRemoveFromJobListProcess = (career_id: any, status: number) => {
    const requestData = {
      career_id: career_id,
      add: status,
    };
    setLoading(true);
    dispatch(addRemoveJob(requestData))
      .then((data: any) => {
        setLoading(false);
        ReloadTable();
      })
      .catch((e: any) => {
        setLoading(false);
        ReloadTable();
      });
    return 123;
  };

  const handleClearAll = () => {
    setSortOrder("ASC");
    setSortBy('name');
    setSelectedCategories([]);
    setSalaryRange(["", ""]);
    setSalaryRangeInput(["", ""]);
    setSelectedCategory("all");
    setShowName("All Categories");
    setInputValue("");
    setSearchValue("");
    setMobileFilterVisible(false); // If you want to close the filter modal as well
    setShowFilterCount(false)
    // setTimeout(() => {
    //   ReloadTable();
    // }, 0);
  };

  const loadMoreData = async () => {
    await dispatch(
      fetchSavedJobs(
        searchValue,
        selectedCategory,
        page,
        sortOrder == "ASC" || sortOrder == "ASC1" ? "ASC" : "DESC",
        salaryRange[0],
        salaryRange[1],
        sortBy
      )
    );
    setPage(page + 1);
  };

  useEffect(() => {
    if (searchValue != "" || selectedCategory != null) {
      ReloadTable();
    }
  }, [searchValue, selectedCategory, sortOrder, salaryRange]);

  return (
    <div className="all-careers-mobile">
      <section className="web-dashboard-section all-career-main">
        <div className="container-fluid">
          <div className="career-index-header mobile-header">
            {screens.md ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 12,
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {/* <h2 className="career-index-title" style={{ marginBottom: 0 }}>
                  Save Careers Index
                </h2> */}
                <BreadcrumbComponent
                  key={1}
                  items={SaveCareersIndexBreadcrumb.path}
                />

                <Input
                  className="career-index-search notranslate"
                  placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}
                  prefix={<SearchOutlined style={{ color: "#bdbdbd" }} />}
                  onChange={(e) => setInputValue(e.target.value)}
                  style={{ maxWidth: 480, borderRadius: 12 }}
                />
              </div>
            ) : (
              <>
                <div className="mobile-header-row">
                  <BreadcrumbComponent
                    key={1}
                    items={SaveCareersIndexBreadcrumb.path}
                  />
                </div>
                <div className="mobile-search-filter-row">
                  <Input
                    className="career-index-search notranslate"
                    placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}
                    style={{ borderRadius: 12, borderColor: "#fff" }}
                    prefix={<SearchOutlined style={{ color: "#bdbdbd" }} />}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                  <div className="filter-icon-wrapper">
                    <Button
                      className="filter-btn-mobile"
                      icon={<SVGIcon icon="filter" width={22} />}
                      onClick={() => setMobileFilterVisible(true)}
                      style={{ backgroundColor: "#fff", borderColor: "#fff" }}
                    />
                    {showFilterCount && (
                      <div onClick={() => setMobileFilterVisible(true)}>
                        <span className="filter-badge">{careerListCount}</span>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="career-index-filters desktop-filters">
              <div className="career-index-filters-row">
                <div
                  style={{ fontSize: 16 }}
                  className="career-index-filter-label"
                >
                  Filter by:
                </div>

                <ConfigProvider
                  theme={{
                    token: {
                      controlItemBgHover: "#DFFBDF", // Example: a light blue for hover
                    },
                  }}
                >
                  <Dropdown
                    menu={{
                      items: CarierCategoryList.map((item: any) => ({
                        ...item,
                        label: item.full_name,
                        value: item.id,
                        key: item.id,
                        onClick: () => {
                          setSelectedCategory(item.code);
                          setShowName(item.full_name);

                          setTimeout(() => {
                            const categoryPass =
                              item.id === "all" ? null : item.code;
                            dispatch(
                              fetchSavedJobs(
                                searchValue,
                                categoryPass,
                                1,
                                sortOrder == "ASC" || sortOrder == "ASC1"
                                  ? "ASC"
                                  : "DESC",
                                salaryRange[0],
                                salaryRange[1],
                                sortBy
                              )
                            );
                          }, 0);
                        },
                      })),
                    }}
                    trigger={["click"]}
                    placement="bottomLeft"
                    open={categoryDropdownOpen}
                    onOpenChange={setCategoryDropdownOpen}
                  >
                    <Space
                      style={{
                        height: 48,
                        border: `1px solid ${categoryDropdownOpen ? "#169C16" : "#e0e0e0"
                          }`,
                        borderRadius: 12,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="custom-sort-btn"
                    >
                      {showName === ""
                        ? "All Categories"
                        : showName.length > 13
                          ? `${showName.slice(0, 13)}...`
                          : showName}
                      <img
                        src={ArrowDown}
                        alt="arrow"
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: 8,
                          transition: "transform 0.2s",
                          transform: categoryDropdownOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: -2,
                        }}
                      />
                    </Space>
                  </Dropdown>
                </ConfigProvider>
                <div
                  className="custom-sort-btn"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    userSelect: "none",
                    height: 48,
                    border: `1px solid ${salaryModalVisible ? "#169C16" : "#e0e0e0"
                      }`,
                    borderRadius: 12,
                  }}
                  onClick={() => setSalaryModalVisible(true)}
                >
                  {salaryRange[0] && salaryRange[1]
                    ? `Salary: ${formatGlobalPrice(
                      salaryRange[0]
                    )} - ${formatGlobalPrice(salaryRange[1])}`
                    : "Salary"}
                  <img
                    src={ArrowDown}
                    alt="arrow"
                    style={{
                      width: 20,
                      height: 20,
                      marginLeft: 8,
                      transition: "transform 0.2s",
                      transform: salaryModalVisible
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                  />
                </div>

                <div
                  className="custom-sort-btn"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    userSelect: "none",
                    justifyContent: "center",
                    borderColor: "red",
                    color: "red",
                    height: 48,
                    borderRadius: 12,
                  }}
                  onClick={() => handleClearAll()}
                >
                  Reset filter
                </div>
              </div>
              <div className="career-index-filters-row">
                <div
                  className="career-index-sort-label"
                  style={{ fontSize: 16 }}
                >
                  Sort by:
                </div>
                <ConfigProvider
                  theme={{
                    token: {
                      controlItemBgHover: "#DFFBDF",
                    },
                  }}
                >
                  <Dropdown
                    open={sortDropdownOpen}
                    onOpenChange={setSortDropdownOpen}
                    trigger={["click"]}
                    placement="bottomRight"
                    dropdownRender={() => (
                      <div
                        className="custom-sort-dropdown"
                        style={{
                          padding: 12,
                          background: "#fff",
                          borderRadius: 12,
                          minWidth: 200,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          {sortOptions.map((option) => (
                            <CustomRadio
                              key={option.value}
                              value={option.value}
                              label={option.label}
                              checked={sortOrder === option.value}
                              onChange={() => {
                                setSortOrder(option.value);
                                const selected = sortOptions.find(
                                  (opt) => opt.value === option.value
                                );
                                setSortBy(selected ? selected.data : "name");
                                setTimeout(() => {
                                  setSortDropdownOpen(false);
                                }, 150); // 100–200ms gives enough time to show selection
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  >
                    <Space
                      style={{
                        height: 48,
                        border: `1px solid ${sortDropdownOpen ? "#169C16" : "#e0e0e0"
                          }`,
                        borderRadius: 12,
                        padding: "0 12px",
                        cursor: "pointer",
                      }}
                      className="custom-sort-btn"
                    >
                      {sortOptions.find((o) => o.value === sortOrder)?.label ||
                        sortOptions[0].label}
                      <img
                        src={ArrowDown}
                        alt="arrow"
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: 8,
                          transition: "transform 0.2s",
                          transform: sortDropdownOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: -2,
                        }}
                      />
                    </Space>
                  </Dropdown>
                </ConfigProvider>
              </div>
            </div>
          </div>

          <FilterModal
            open={mobileFilterVisible}
            onClose={() => {
              setMobileFilterVisible(false);
              // ReloadTable();
            }}
            sortOptions={sortOptions}
            sortOrder={sortOrder}
            sortBy={sortBy}
            setSortOrder={setSortOrder}
            setSortBy={setSortBy}
            categoryList={CarierCategoryList}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            salaryRange={salaryRange}
            setSalaryRange={setSalaryRange}
            handleClearAll={handleClearAll}
            setSelectedCategory={setSelectedCategory} // Add this
            setShowName={setShowName} // Add this
            setShowFilterCount={setShowFilterCount}
          />
          {/* Header Section End */}
          <div className="career-list">
            <InfiniteScroll
              dataLength={savedjobs.length}
              next={loadMoreData}
              hasMore={savedjobs.length < careerListPagination?.total}
              loader={
                loading ? (
                  <Skeleton avatar paragraph={{ rows: 1 }} active />
                ) : null
              }
              scrollableTarget="scrollableDiv"
            >
              {savedjobs && savedjobs.length > 0 ? (
                savedjobs.map((item: any) => (
                  <Card
                    className="career-card-row"
                    key={item.id}
                    variant={'borderless'}
                    styles={{ body: { padding: "24px" } }}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate(`/careers/details/${item.id}`);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: 22,
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h2
                            className="career-card-title"
                            style={{
                              whiteSpace: "wrap",
                              fontSize: 24,
                              color: "#000",
                              marginBottom: 8,
                              fontWeight: 600,
                            }}
                          >
                            {item.name}
                          </h2>

                          {!screens.md && (
                            <div className="examTooltip-mobile" style={{ placeSelf: "start" }}>
                              <Tooltip
                                placement="top"
                                title={"Remove from Saved List"}
                                className="examTooltip-mobile"
                              >
                                <Button
                                  className="common_button rounded green-btn save-button"
                                  disabled={loading ? true : false}
                                  icon={
                                    <SVGIcon
                                      icon="SavedFilled"
                                      width={30}
                                      color={"#169C16"}
                                    />
                                  }
                                  onClick={(e) => {
                                    setLoading(true);
                                    e.stopPropagation();
                                    SaveAndRemoveFromJobListProcess(item.id, 0);
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        </div>

                        <span
                          style={{
                            color: "#0981AA",
                            fontSize: 16,
                            display: "inline-block",
                          }}
                        >
                          {item.categories && item.categories.length > 0
                            ? item.categories
                              .map((cat: any) => cat.category?.name)
                              .filter(Boolean)
                              .join(", ")
                            : "-"}
                        </span>

                        <div
                          style={{
                            color: "#555",
                            fontSize: 15,
                            marginTop: 8,
                            maxWidth: "95%",
                          }}
                        >
                          {(() => {
                            const desc = item.description
                              ? stripHtml(item.description)
                              : "";
                            if (
                              typeof window !== "undefined" &&
                              window.innerWidth <= 767
                            ) {
                              return desc.length > 100
                                ? desc.slice(0, 100) + "..."
                                : desc;
                            } else {
                              return desc.length > 200
                                ? desc.slice(0, 200) + "..."
                                : desc;
                            }
                          })()}
                        </div>

                        <div
                          className="card-price"
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            marginTop: "4%",
                            color: "#222",
                          }}
                        >
                          {formatGlobalPrice(item.salary_start)} -{" "}
                          {formatGlobalPrice(item.salary_end)}
                        </div>
                      </div>

                      <div
                        className="tooltip-button"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignSelf: "center",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          minWidth: 180,
                          gap: 12,
                          borderWidth: 1,
                        }}
                      >
                        <div className="examTooltip">
                          <Tooltip
                            placement="top"
                            title={
                              item.is_saved
                                ? "Remove from Saved List"
                                : "Add to Saved List"
                            }
                          >
                            <Button
                              className="common_button rounded green-btn save-button"
                              disabled={loading ? true : false}
                              icon={
                                <SVGIcon
                                  icon="SavedFilled"
                                  width={30}
                                  color={"#169C16"}
                                />
                              }
                              onClick={(e) => {
                                if (loading) return;
                                e.stopPropagation(); // ✅ prevent navigation
                                setLoading(true);
                                SaveAndRemoveFromJobListProcess(item.id, 0);
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: "#222",
                            alignItems: "flex-end",
                            justifyContent: "flex-end",
                            display: "flex",
                            marginRight:
                              item.salary_start == null &&
                                item.salary_end == null
                                ? 10
                                : 0,
                          }}
                        >
                          {formatGlobalPrice(item.salary_start)} -{" "}
                          {formatGlobalPrice(item.salary_end)}
                        </div>
                      </div>
                    </div>
                  </Card>
                ))
              ) : loading ? (
                <Skeleton avatar paragraph={{ rows: 1 }} active />
              ) : (
                <div>No careers found.</div>
              )}
            </InfiniteScroll>
          </div>
        </div>
      </section>

      <Modal
        title="Select Salary Range"
        open={salaryModalVisible}
        centered
        onCancel={() => setSalaryModalVisible(false)}
        maskClosable={true}
        closeIcon={false}
        onOk={undefined}
        footer={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: 10,
            }}
          >
            <Button
              style={{
                borderColor: "#169C16",
                color: "#169C16",
                background: "transparent",
                boxShadow: "none",
                transition: "none",
              }}
              onClick={() => setSalaryModalVisible(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                // ReloadTable();
                setSalaryRange(salaryRangeInput);
                setSalaryModalVisible(false);
              }}
            >
              OK
            </Button>
          </div>
        }
      >
        <div style={{ margin: "24px 0" }}>
          <ConfigProvider
            theme={{
              components: {
                Slider: {
                  handleColor: "#0B400C",
                  handleLineWidth: 3,
                  handleLineWidthHover: 3,
                  handleActiveColor: "#0B400C",
                  handleActiveOutlineColor: "rgba(11, 64, 12, 0.2)",
                  trackBg: "#0B400C",
                  railBg: "#E2E8F0",
                  controlSize: 20, // Optional: height of slider
                },
              },
            }}
          >
            <Slider
              range
              min={parseFloat(CONSTANT.MIN_SALARY)}
              max={parseFloat(CONSTANT.MAX_SALARY)}
              step={1000}
              value={salaryRangeInput.map(Number)}
              onChange={(value) =>
                setSalaryRangeInput(
                  (value as number[]).map(String) as [string, string]
                )
              }
              className="custom-slider"
              tooltip={{ formatter: (v) => <div className="notranslate">{`$${v}`}</div> }}

              dots={false}
              styles={{
                handle: {
                  color: "#0B400C",
                  borderColor: "#0B400C",
                  backgroundColor: "#0B400C",
                },
                track: {
                  backgroundColor: "#0B400C",
                },
                rail: {
                  backgroundColor: "#E2E8F0",
                },
              }}
            />
          </ConfigProvider>
          <div
            style={{
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              display: "flex",
              marginTop: 20,
            }}
          >
            <Input
              style={{ width: "45%", height: 50 }}
              type="number"
              min={parseFloat(CONSTANT.MIN_SALARY)}
              max={salaryRangeInput[1]}
              value={salaryRangeInput[0]}
              onChange={(e: any) => {

                const val1 = e.target.value;
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setSalaryRangeInput([CONSTANT.MAX_SALARY, salaryRangeInput[1]])
                  return;
                }
                if (parseFloat(val1) < parseFloat(CONSTANT.MIN_SALARY)) {
                  setSalaryRangeInput([CONSTANT.MIN_SALARY, salaryRangeInput[1]])
                  return;
                }
                const val2 = salaryRangeInput[1];

                setSalaryRangeInput([val1, val2])
              }}
            />
            <span className="salary-separator">-</span>
            <Input
              style={{ width: "45%", height: 50 }}
              type="number"
              min={salaryRangeInput[0]}
              max={parseFloat(CONSTANT.MAX_SALARY)}
              value={salaryRangeInput[1]}
              onChange={(e: any) => {
                const val1 = e.target.value;
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setSalaryRangeInput([salaryRangeInput[0], CONSTANT.MAX_SALARY])
                  return;
                }
                if (parseFloat(val1) < parseFloat(CONSTANT.MIN_SALARY)) {
                  setSalaryRangeInput([salaryRangeInput[0], CONSTANT.MIN_SALARY])
                  return;
                }
                const val2 = salaryRangeInput[0];

                setSalaryRangeInput([val2, val1])
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 6,
            }}
          >
            <span>Min: {formatGlobalPrice(salaryRangeInput[0])}</span>
            <span>Max: {formatGlobalPrice(salaryRangeInput[1])}</span>
          </div>
        </div>
      </Modal>
      {screens.xl == false &&
        scrollY > 1 &&
        <BackTop
          visibilityHeight={1000}
          children={<Button type="primary" icon={<ArrowUpOutlined />} />}
        />}
    </div>

  );
};

export default SavedJobs;
